import has from 'lodash/has';
import forEach from 'lodash/forEach';

enum IvrPublishDomainError {
  undefinedNextIds = 'undefinedNextIds',
  infiniteLoop = 'infiniteLoop',
}

const IvrPublishDomainErrorMessage = {
  [IvrPublishDomainError.undefinedNextIds]: 'Undefined next node',
  [IvrPublishDomainError.infiniteLoop]: 'Infinite loop detected',
};

const translateIvrPublishServerErrors = errors => {
  const translatedErrors: any = [];

  forEach(errors, error => {
    if (error.code === 'invalid' && error.detail) {
      try {
        const errorDetail = JSON.parse(error.detail);
        const nodeIds = Object.keys(errorDetail);

        forEach(nodeIds, nodeId => {
          const error = Object.keys(errorDetail[nodeId])[0];
          const errorMessage = has(IvrPublishDomainError, error)
            ? IvrPublishDomainErrorMessage[error]
            : 'Unknown error';

          translatedErrors.push({
            attr: `nodesMap.${nodeId}.ivrNode`,
            code: has(IvrPublishDomainError, error) ? error : 'unknown',
            nodeId,
            detail: errorMessage,
          });
        });
      } catch (e) {
        translatedErrors.push(error);
      }
    } else {
      translatedErrors.push(error);
    }
  });
  return translatedErrors;
};

export { translateIvrPublishServerErrors };
